import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import myImage from "../images/801A0068.jpg";
import "./EventsSection.css";

const events = [
  {
    img: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80",
    date: "August 2023",
    title: "Past Event: Pediatric Urology Awareness Camp",
    descr:
      "A successful awareness camp for families and children, providing free checkups and consultations with leading pediatric urologists.",
    venue: "Solapur, Maharashtra, India",
  },
  {
    img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=800&q=80",
    date: "March 2023",
    title: "Past Event: Free Surgery Camp",
    descr:
      "Dozens of children received life-changing surgeries and support, thanks to the Gundeti Foundation and its partners.",
    venue: "Solapur, Maharashtra, India",
  },
  {
    img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    date: "December 2024",
    title:
      "Bringing Hope: Medical Aid and Urological Surgeries for Children in Solapur",
    descr:
      "We are proud to announce a life-changing initiative aimed at improving the health and well-being of children suffering from urological anomalies. This December in Solapur, our team of dedicated medical professionals, surgeons, and volunteers will come together to provide specialized medical aid and surgeries to children who are in urgent need of treatment. Our project is focused on addressing these issues with cutting-edge medical care and providing families with the hope they deserve.",
    venue: "Solapur, Maharashtra, India",
  },
];

// Add new demo upcoming event for December 2025
const upcomingEvents = [
  {
    // img: "https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=800&q=80",
    img: myImage,
    date: "Monday, November 17th 2025 | Time: 8.00am to 12.00am",
    title: "9th Annual Pediatric Urology Free camp",
    descr:
      "Join us for the 9th Annual Pediatric Urology Free Camp in November 2025, organized by the Gundeti Foundation – Health & Education. Led by Dr. Mohan S. Gundeti, Professor of Urology & Pediatrics at the University of Chicago, this free camp will provide consultations on November 16th and surgeries on November 17th at Shri Markandey Solapur Sahakari Rugnalaya & Research Center, Solapur. Together, we aim to advance pediatric urological care and bring hope to families in need. For appointments, contact (0217) 2651399 / 09922936339 / 08956802999 or email gundetifoundation@gmail.com.",
    venue:
      "Shri Markandey Solapur Cooperative Medical Research Center, Solapur-413006",
  },
];

const pastEvents = events;

const cardVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.7, ease: "easeOut" },
  }),
};

const CARD_HEIGHT = 500;

const EventCard = ({ event, idx, onReadMore }) => {
  const shortText =
    event.descr.length > 120 ? event.descr.slice(0, 120) + "..." : event.descr;
  return (
    <motion.div
      className="events-past-card"
      custom={idx}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={cardVariant}
      style={{ minWidth: 340, flex: "0 0 340px", scrollSnapAlign: "start" }}
    >
      <Card
        className="events-past-card-inner"
        sx={{
          borderRadius: 5,
          boxShadow: 6,
          background: "var(--color-white)",
          transition: "transform 0.3s, box-shadow 0.3s",
          "&:hover": {
            transform: "translateY(-8px) scale(1.03)",
            boxShadow: 12,
          },
          minHeight: CARD_HEIGHT,
          height: CARD_HEIGHT,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardMedia
          className="events-past-image"
          component="img"
          image={event.img}
          alt={event.title}
          sx={{
            height: 200,
            objectFit: "cover",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
          }}
        />
        <CardContent
          className="events-past-content"
          sx={{ flex: 1, display: "flex", flexDirection: "column", p: 3 }}
        >
          <Typography
            className="events-past-date"
            variant="subtitle2"
            sx={{
              color: "var(--color-accent-blue)",
              fontWeight: 700,
              mb: 1,
              letterSpacing: 1,
            }}
          >
            {event.date}
          </Typography>
          <Typography
            className="events-past-title"
            variant="h6"
            sx={{
              fontWeight: 800,
              mb: 1,
              color: "var(--color-black)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {event.title}
          </Typography>
          <Typography
            className="events-past-description"
            variant="body2"
            sx={{
              color: "var(--color-black)",
              mb: 2,
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              minHeight: 72,
            }}
          >
            {shortText}
          </Typography>
          {event.descr.length > 120 && (
            <Button
              className="events-past-read-more"
              size="small"
              onClick={onReadMore}
              sx={{
                color: "var(--color-accent-blue)",
                fontWeight: 700,
                textTransform: "none",
                alignSelf: "flex-start",
                px: 0,
              }}
            >
              Read More
            </Button>
          )}
          <Box sx={{ mt: "auto" }}>
            <Typography
              className="events-past-venue-label"
              variant="caption"
              sx={{ color: "var(--color-accent-green)", fontWeight: 600 }}
            >
              Venue:
            </Typography>
            <Typography
              className="events-past-venue-text"
              variant="body2"
              sx={{ color: "var(--color-accent-blue)", fontWeight: 700 }}
            >
              {event.venue}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

const EventsSection = () => {
  const [modalIdx, setModalIdx] = useState(null);
  const [modalType, setModalType] = useState("upcoming");
  return (
    <Box
      className="events-container"
      component={motion.div}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      sx={{
        background: "none",
        py: 10,
        fontFamily: "Poppins, Arial, sans-serif",
      }}
    >
      <Container>
        <Box
          className="events-inner-container"
          sx={{
            background: "#f7fbff",
            borderRadius: "2.5rem",
            maxWidth: 1100,
            mx: "auto",
            mb: 4,
            mt: 0,
            pt: 0,
            p: { xs: 2, md: 6 },
            boxShadow: "0 2px 16px 0 rgba(0,0,0,0.04)",
          }}
        >
          <Typography
            className="events-main-title"
            variant="h3"
            sx={{
              fontWeight: 900,
              color: "var(--color-black)",
              mb: 2,
              textAlign: "center",
              letterSpacing: 1,
            }}
          >
            Upcoming & Past Events
          </Typography>
          <Typography
            className="events-subtitle"
            variant="h6"
            sx={{
              color: "var(--color-accent-green)",
              mb: 6,
              textAlign: "center",
              fontWeight: 600,
            }}
          >
            See how we are making an impact in children's lives
          </Typography>
          {/* Upcoming Events News Flash Section */}
          {upcomingEvents.length > 0 && (
            <motion.div
              className="events-upcoming-section"
              initial={{ opacity: 0, scale: 0.96, x: -120 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              style={{ marginBottom: 64 }}
            >
              <Typography
                className="events-upcoming-title"
                variant="h4"
                sx={{
                  color: "var(--color-accent-blue)",
                  fontWeight: 800,
                  mb: 3,
                }}
              >
                Upcoming Events
              </Typography>
              {upcomingEvents.map((event, idx) => (
                <Box
                  key={event.title}
                  className="events-upcoming-card"
                  sx={{
                    position: "relative",
                    minHeight: { xs: 340, md: 420 },
                    borderRadius: 6,
                    overflow: "hidden",
                    boxShadow: 8,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "var(--color-white)",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      backgroundImage: `url(${event.img})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      filter: "brightness(0.6)",
                      zIndex: 1,
                    }}
                  />
                  <Box
                    className="events-upcoming-content"
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      color: "var(--color-white)",
                      p: { xs: 3, md: 8 },
                      width: "100%",
                      maxWidth: 900,
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    <Typography
                      className="events-upcoming-badge"
                      variant="overline"
                      sx={{
                        color: "var(--color-accent-green)",
                        fontWeight: 900,
                        fontSize: "1.1rem",
                        letterSpacing: 2,
                        mb: 1,
                        display: "block",
                      }}
                    >
                      NEW EVENT COMING!
                    </Typography>
                    <Typography
                      className="events-upcoming-date"
                      variant="h5"
                      sx={{
                        color: "var(--color-accent-green)",
                        fontWeight: 700,
                        mb: 1,
                      }}
                    >
                      {event.date}
                    </Typography>
                    <Typography
                      className="events-upcoming-event-title"
                      variant="h4"
                      sx={{
                        fontWeight: 900,
                        mb: 2,
                        color: "var(--color-white)",
                        lineHeight: 1.1,
                      }}
                    >
                      {event.title}
                    </Typography>
                    <Typography
                      className="events-upcoming-description"
                      variant="body1"
                      sx={{
                        color: "var(--color-white)",
                        mb: 2,
                        fontWeight: 500,
                      }}
                    >
                      {event.descr.length > 180 ? (
                        <>
                          {event.descr.slice(0, 180)}...
                          <Box
                            component="span"
                              className="events-upcoming-readmore"
                            sx={{
                              color: "var(--color-light-blue)",
                              fontWeight: 700,
                              textDecoration: "none",
                              cursor: "pointer",
                              fontSize: "0.98em",
                              ml: 0.5,
                            }}
                            onClick={() => {
                              setModalIdx(idx);
                              setModalType("upcoming");
                            }}
                          >
                            Read more
                          </Box>
                        </>
                      ) : (
                        event.descr
                      )}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                      <Button
                        className="events-upcoming-button"
                        variant="contained"
                        href="/registration"
                        sx={{
                          backgroundColor: "var(--color-accent-blue)",
                          color: "var(--color-white)",
                          borderRadius: 999,
                          px: 4,
                          py: 1.2,
                          fontWeight: 700,
                          fontSize: "1rem",
                          textTransform: "uppercase",
                          boxShadow: "0 2px 12px 0 var(--color-accent-blue)33",
                          "&:hover": {
                            backgroundColor: "var(--color-accent-green)",
                          },
                        }}
                      >
                        Register Now
                      </Button>
                    </Box>
                    <Typography
                      className="events-upcoming-venue"
                      variant="subtitle2"
                      sx={{
                        color: "var(--color-accent-green)",
                        fontWeight: 600,
                        mt: 2,
                      }}
                    >
                      Venue:{" "}
                      <span
                        style={{
                          color: "var(--color-accent-blue)",
                          fontWeight: 700,
                        }}
                      >
                        {event.venue}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              ))}
            </motion.div>
          )}
          {/* Past Events Section */}
          {/* <Typography
            className="events-past-title"
            variant="h5"
            sx={{ color: "var(--color-accent-blue)", fontWeight: 800, mb: 3 }}
          >
            Past Events
          </Typography> */}
          {/* <Box
            className="events-past-container"
            sx={{
              display: "flex",
              gap: 4,
              overflowX: { xs: "auto", md: "visible" },
              pb: { xs: 2, md: 0 },
              scrollSnapType: { xs: "x mandatory", md: "none" },
              justifyContent: "center",
            }}
          >
            {pastEvents.map((event, idx) => (
              <EventCard
                event={event}
                idx={idx}
                key={event.title}
                onReadMore={() => {
                  setModalIdx(idx);
                  setModalType("past");
                }}
              />
            ))}
          </Box> */}
        </Box>
        {/* Modal for full event info */}
        <Dialog
          open={modalIdx !== null}
          onClose={() => setModalIdx(null)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: "hidden",
              background: "rgba(255,255,255,0.98)",
            },
          }}
        >
          {modalIdx !== null &&
            (() => {
              const event =
                modalType === "upcoming"
                  ? upcomingEvents[modalIdx]
                  : pastEvents[modalIdx];
              return (
                <>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: 240,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={event.img}
                      alt={event.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <IconButton
                      onClick={() => setModalIdx(null)}
                      sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        color: "var(--color-white)",
                        background: "rgba(0,0,0,0.4)",
                        "&:hover": { background: "rgba(0,0,0,0.7)" },
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "var(--color-accent-blue)",
                        fontWeight: 700,
                        mb: 1,
                        letterSpacing: 1,
                      }}
                    >
                      {event.date}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 900,
                        color: "var(--color-black)",
                        mb: 2,
                        letterSpacing: 1,
                      }}
                    >
                      {event.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ fontWeight: 500, mb: 2 }}
                    >
                      {event.descr}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mt: 4,
                        mb: 0,
                        gap: 2,
                        flexWrap: "wrap",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "var(--color-accent-green)",
                            fontWeight: 600,
                            mr: 1,
                          }}
                        >
                          Venue:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "var(--color-accent-blue)",
                            fontWeight: 700,
                            display: "inline",
                          }}
                        >
                          {event.venue}
                        </Typography>
                      </Box>
                      {modalType === "upcoming" && (
                        <Button
                          variant="contained"
                          href="/registration"
                          sx={{
                            backgroundColor: "var(--color-accent-blue)",
                            color: "var(--color-white)",
                            borderRadius: 999,
                            px: 4,
                            py: 1.2,
                            fontWeight: 700,
                            fontSize: "1rem",
                            textTransform: "uppercase",
                            boxShadow:
                              "0 2px 12px 0 var(--color-accent-blue)33",
                            "&:hover": {
                              backgroundColor: "var(--color-accent-green)",
                            },
                          }}
                        >
                          Register Now
                        </Button>
                      )}
                    </Box>
                  </DialogContent>
                </>
              );
            })()}
        </Dialog>
      </Container>
    </Box>
  );
};

export default EventsSection;
